import React from 'react';
import PropTypes from 'prop-types';
import ChangeLensWidget from 'components/widgets/ChangeLensWidget';
import SkipPackWidget from 'components/widgets/SkipPackWidget';
import styled from 'styled-components';
import OrderTopupWidget from 'components/widgets/OrderTopupWidget';
import LinkHeading from 'components/LinkHeading';

const OtherActionsWrapper = styled.section`
  > .widgetContainer {
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const ChangeLensView = ({
  className,
  plans,
  onSubmit,
  onCancel,
  nextPackId,
  canTopUp,
  solution,
}) => {
  const classes = ['ChangeLensView', className];

  const renderOtherActions = () => {
    const otherActions = [];
    if (nextPackId) {
      otherActions.push(
        <SkipPackWidget key="skipPackWidget" packId={nextPackId} />,
      );
    }
    if (canTopUp) {
      otherActions.push(<OrderTopupWidget key="orderTopupWidget" />);
    }
    return otherActions.length ? (
      <OtherActionsWrapper>
        <LinkHeading title="Other actions" />
        {otherActions}
      </OtherActionsWrapper>
    ) : null;
  };

  return (
    <div className={classes.filter((c) => !!c).join(' ')}>
      {plans && (
        <ChangeLensWidget
          plans={plans}
          onSubmit={onSubmit}
          onCancel={onCancel}
          solution={solution}
        />
      )}

      {renderOtherActions()}
    </div>
  );
};

ChangeLensView.displayName = 'ChangeLensView';

ChangeLensView.propTypes = {
  className: PropTypes.string,
  plans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  nextPackId: PropTypes.string,
  canTopUp: PropTypes.bool.isRequired,
  solution: PropTypes.shape({}),
};

ChangeLensView.defaultProps = {
  className: undefined,
  solution: undefined,
  nextPackId: null,
};

export default ChangeLensView;
